export const SEARCH_SLICE = "search";